<template>
  <div>
    <section class="content">
      <div class="pull-right btn-information col-xs-2">
        <button
          class="btn btn-info btn-information-save"
          v-on:click="handleSave"
        >Save</button>
        <button
          class="btn btn-default btn-information-cancel"
          v-on:click="goBack"
        >Cancel</button>
      </div>

      <app-data-form ref="form"/>
    </section>

    <!-- del APP -->
    <!--<div class="del-app-bgcolor">-->
    <!--<span class="btn del-app pull-right"><i class="fa fa-times"></i></span>-->
    <!--</div>-->
    <!-- /del APP -->
  </div>
</template>
<script>
import AppDataForm from "../modules/AppDataForm";

export default {
  name: "AddApp",
  components: {
    AppDataForm
  },
  methods: {
    async handleSave() {
      await this.$refs.form.create();
      this.$router.push("/");
    },
    goBack() {
      this.$router.push("/");
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// AddApp.vue?6414950e